import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";
import line1 from "./images/line1.svg";
import line2 from "./images/line2.svg";

type Props = {
  steps: { title: string; icon: any }[];
};

const bem = new BemHelper("contacts-steps");

export const Steps: React.FC<Props> = ({ steps = [] }) => {
  console.log(encodeURI(line2));

  return (
    <div className={classNames(bem.block())}>
      <div className={classNames(bem.element("title-main"))}>3 steps</div>
      <div className={classNames(bem.element("block"))}>
        {steps.map((step, key) => (
          <React.Fragment key={key}>
            <div
              className={classNames(
                bem.element("wall"),
                key + 1 >= steps.length && bem.modifier(`none`, "wall"),
              )}
            >
              <div className={classNames(bem.element("box"))}>
                <div
                  className={classNames(bem.element("image"), bem.modifier(`${key + 1}`, "image"))}
                >
                  {step.icon}
                </div>
                <div
                  className={classNames(
                    bem.element("title-step"),
                    bem.modifier(`${key + 1}`, "title-step"),
                  )}
                >
                  {`Step ${key + 1}`}
                </div>
                <div className={classNames(bem.element("title"))}>{step.title}</div>
              </div>
              {key + 1 < steps.length && (
                <div
                  className={classNames(bem.element("line"))}
                  style={{ background: `url("${key == 0 ? line1 : line2}")` }}
                />
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
